import $ from 'jquery';
import 'jquery-validation';
import { isValid } from './ibanHelper';

window.$ = window.jQuery = $;

const Validator = (() => {
    const ERROR_CLASS = 'is-invalid';
    const ERROR_ELEMENT = '.invalid-feedback';
    const CREDIT_CARD_NAME = 'brandCode';
    const BIRTHDAY_NAME = $('[name*=birthdate]').attr('name');
    const ACCOUNT_NUMBER_NAME = $('[name*=accountNumber]').attr('name');
    const VALIDATION_FIELD = $('.js-check-validation').attr('name');
    const ERROR_PAYMENT = $('#requiredBrandCode').data('msg-required');
    const ERROR_INVALID_IBAN = $('[name*=accountNumber]').attr('data-msg-pattern');
    const INPUT_WRAP = '.input-row';
    const SELECT_WRAP = '.select-wrap';
    const EMAIL_NAME = $('[name*=email]').attr('name');
    const CONFIRM_EMAIL = $('[name*=emailconfirm]').attr('name');
    const ERROR_CONFIRM_EMAIL = $('[name*=emailconfirm]').attr('data-msg-notmatch');
    const MIN_AGE = 16;
    const MIN_DATE_YEARS = 120;
    const NOW = new Date();
    const MIN_DATE = new Date(NOW.getFullYear() - MIN_DATE_YEARS, NOW.getMonth(), NOW.getDate(), 0, 0, 0, 0);
    let validator;
    const laptopMaxWidth = 1025;
    const $emailValidation = $('.js-email-validation');
    const $emailContainer = $('.email-container');
    const isEmailValidationNL = $emailContainer.hasClass('js-email-validation-version1') || $emailContainer.hasClass('js-email-validation-version2') || $emailContainer.hasClass('js-email-validation-version3');

    const initCheckMailUsedBefore = () => {
        $('.js-button').on('click', (event) => {
            event.preventDefault();
            const field = $('.js-used-mail :input');
            let url = $('.js-used-mail').attr('data-url');
            const mail = field[0].value;
            url += `?&mail=${mail}`;
            $.ajax({
                url,
                success(response) {
                    const valCheck = $('.js-check-validation');
                    if (!!response.mailUsedBefore) {
                        $('.js-show-used-mail').show();
                        $('.js-used-mail input').addClass(ERROR_CLASS);
                        valCheck.val('');
                    } else {
                        $('.js-show-used-mail').hide();

                        if ($emailValidation.length > 0) {
                            $('.js-used-mail.emailconfirm-container input').removeClass(ERROR_CLASS);
                        } else {
                            $('.js-used-mail input').removeClass(ERROR_CLASS);
                        }

                        valCheck.val(true);
                        $('.js-personal-information-form').submit();
                    }
                },
            });
        });

        $('.js-used-mail input').on('change', () => {
            $('.js-show-used-mail').hide();
        });

        $(document).on('copy cut paste', '.js-used-mail input', (e) => {
            e.preventDefault();
        });
    };

    const defaultParams = {
        errorClass: ERROR_CLASS,
        errorElement: 'span',
        ignore: '',
        unhighlight(element, errorClass) {
            if ($(element).closest('.js-email-validation').length > 0) {
                return;
            }

            $(element)
                .removeClass(errorClass)
                .closest(INPUT_WRAP).removeClass(errorClass);
        },
        errorPlacement($error, $element) {
            if ($element.attr('type') === 'checkbox' || $element.attr('type') === 'radio') {
                $error.appendTo($element.closest(INPUT_WRAP).addClass(ERROR_CLASS).find(ERROR_ELEMENT).empty());
            } else if ($element.is('select')) {
                $error.appendTo($element.closest(SELECT_WRAP).siblings(ERROR_ELEMENT).empty());
            } else {
                $error.appendTo($element.siblings(ERROR_ELEMENT).empty());
            }
        },
        rules: {
            [BIRTHDAY_NAME]: {
                minAge: MIN_AGE,
                minDate: MIN_DATE,
            },
            [ACCOUNT_NUMBER_NAME]: {
                IbanNumber: true,
            },
            [VALIDATION_FIELD]: {
                required: true,
            },
            [EMAIL_NAME]: {
                email: true,
            },
            [CONFIRM_EMAIL]: {
                confirmEmail: !isEmailValidationNL,
            },
        },
        messages: {
            [CREDIT_CARD_NAME]: {
                required: ERROR_PAYMENT,
            },
            [ACCOUNT_NUMBER_NAME]: {
                IbanNumber: ERROR_INVALID_IBAN,
            },
            [CONFIRM_EMAIL]: {
                confirmEmail: ERROR_CONFIRM_EMAIL,
            },
        },
        focusInvalid: false,
        // focusInvalid: false is needed for the error scrolling below to work:
        invalidHandler(form, validator) {
            // stop if no errors
            if (!validator.numberOfInvalids()) return;

            // on touch devices the summary in the checkout takes space on top
            if ($(window).innerWidth() < laptopMaxWidth && $('.checkout-navigation > .js-checkout-order-summary').css('display') === 'block') {
                const summaryHeight = $('.checkout-navigation > .js-checkout-order-summary').outerHeight();
                // scroll to first error touch
                $('html, body').animate({ scrollTop: $(validator.errorList[0].element).offset().top - (summaryHeight + 5) }, 500);
            } else {
                // scroll to first error desktop
                $('html, body').animate({ scrollTop: $(validator.errorList[0].element).offset().top - 5 }, 500);
            }
        },
    };

    if ($emailValidation.length > 0) {
        delete defaultParams.rules[EMAIL_NAME];
    }

    function validPattern(value, element, param) {
        let pattern;

        if (this.optional(element)) {
            return true;
        }
        if (typeof param === 'string') {
            pattern = new RegExp(param);
        }
        const testPatern = pattern ? pattern.test(value) : ' ';

        return testPatern;
    }

    $.validator.addMethod('pattern', validPattern);

    $.validator.addMethod('minAge', (value, element, min = MIN_AGE) => {
        const today = new Date();
        const birthDate = new Date(value);
        let age = today.getFullYear() - birthDate.getFullYear();

        if (age > min + 1) {
            return true;
        }

        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= min;
    });

    // eslint-disable-next-line no-unused-vars
    $.validator.addMethod('email', (value, _) => {
        return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value));
    });

    // eslint-disable-next-line no-unused-vars
    $.validator.addMethod('IbanNumber', (value, _) => {
        const valid = isValid(value.replace(/\s+/g, ''));

        return valid;
    });

    $.validator.addMethod('minDate', (value, element, minDate = MIN_DATE) => new Date(value) > minDate);

    if (!isEmailValidationNL) {
        // eslint-disable-next-line no-unused-vars
        $.validator.addMethod('confirmEmail', (value, _) => {
            if (value.trim().toLowerCase() !== $('[name*=email]').val().trim().toLowerCase()) {
                return false;
            }
            return true;
        });
    }

    const enableBtnOnCheckbox = () => {
        // checkbox toggle change event
        $('.terms-and-conditions-checkbox').on('change', () => {
            $('.js-personal-btn').toggleClass('disabled');
        });

        // on page load check
        if ($('.terms-and-conditions-checkbox:checked').length > 0) {
            $('.js-personal-btn').removeClass('disabled');
        } else {
            $('.js-personal-btn').addClass('disabled');
        }
    };

    return {
        init(wrapperID = 'body', options = {}) {
            const settings = {
                ...defaultParams,
                ...options,
            };

            $(wrapperID).find('form').each((index, form) => {
                validator = $(form).validate(settings);
            });

            initCheckMailUsedBefore();
            enableBtnOnCheckbox();
        },
        resetForm() {
            validator.resetForm();
        },
        initForm(formId, options = {}) {
            const settings = {
                ...defaultParams,
                ...options,
            };

            $(formId).validate(settings);
        },
    };
})();


export default Validator;
